'use client';

;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import React, { PropsWithChildren, useMemo, useState } from 'react';
import useSWR from 'swr';
import { getAnnouncement } from '@/components/organisms/Header/components/AlertsAndAnnouncements/utils';
import { useLang } from '@/hooks/useLang';
import { AnnouncementContext } from './consts';
import { Announcement } from './types';
type AnnouncementContextProviderProps = PropsWithChildren<{
  initialAnnouncement: Announcement;
}>;
const AnnouncementContextProvider: React.FC<AnnouncementContextProviderProps> = ({
  initialAnnouncement,
  children
}) => {
  const lang = useLang();
  const [isDismissed, setIsDismissed] = useState(false);

  // The server-rendered value owns the first paint; refetching on mount would let a stale
  // response move the page. Focus revalidation still reaches visitors already on the page.
  const {
    data
  } = useSWR<Announcement>(['announcement', lang], () => getAnnouncement(lang), {
    fallbackData: initialAnnouncement,
    revalidateOnMount: false
  });
  const value = useMemo(() => ({
    announcement: isDismissed ? null : data ?? null,
    dismiss: () => setIsDismissed(true)
  }), [data, isDismissed]);
  return <AnnouncementContext.Provider value={value} data-sentry-element="AnnouncementContext.Provider" data-sentry-component="AnnouncementContextProvider" data-sentry-source-file="index.tsx">{children}</AnnouncementContext.Provider>;
};
export default AnnouncementContextProvider;